import { render, staticRenderFns } from "./TransTextHistory.vue?vue&type=template&id=2450c604&scoped=true&"
import script from "./TransTextHistory.vue?vue&type=script&lang=js&"
export * from "./TransTextHistory.vue?vue&type=script&lang=js&"
import style0 from "./TransTextHistory.vue?vue&type=style&index=0&id=2450c604&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2450c604",
  null
  
)

export default component.exports